<!--Modal confirmation-->
<p-dialog
    header="{{ 'projects.pages.details.closeProject' | translate }}"
    [(visible)]="visible"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    appendTo="body"
    (onHide)="closeModal()"
>
    <div class="modal-image">
        <img src="{{ project.pictureAccessLink }}" alt="" />
    </div>
    <div class="modal-body">
        <p class="ta-c lead">
            {{ 'projects.pages.details.closeProjectWarning' | translate }}
        </p>
        <p class="ta-c lead">{{ 'projects.pages.details.close.status' | translate }}</p>
        <p class="ta-c lead">{{ 'projects.pages.details.close.confirm' | translate }}</p>
    </div>
    <p-footer>
        <button type="button" class="btn btn-secondary" (click)="closeModal()">
            {{ 'components.button.buttonCancel' | translate }}
        </button>
        <button type="button" class="btn btn-primary" (click)="showRateModal()">
            {{ 'components.button.buttonYes' | translate }}
        </button>
    </p-footer>
</p-dialog>

<!--Modal note-->
<p-dialog
    header="{{ 'projects.pages.details.closeProject' | translate }}"
    [(visible)]="rateModalVisible"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    appendTo="body"
    (onHide)="closeRateModal()"
>
    <div class="modal-image">
        <img src="{{ project.pictureAccessLink }}" alt="" />
    </div>
    <div class="modal-body">
        <p class="ta-c lead">
            {{ 'projects.pages.details.closingProject' | translate }}
        </p>
        <p class="ta-c lead">{{ 'projects.pages.details.close.leaveMessage' | translate }}</p>
        <p class="ta-c lead">{{ 'projects.pages.details.close.leaveQuestion' | translate }}</p>

        <div class="row vote justify-content-center">
            <ngb-rating max="5" [(rate)]="currentRate">
                <ng-template let-fill="fill" let-index="index">
                    <div class="col-auto justify-content-center">
                        <span class="vote__star vote__star-default" [class.vote__star-active]="fill === 100">
                            <svg version="1.1" x="0px" y="0px" viewBox="0 0 511 511" xml:space="preserve">
                                <path
                                    d="M509.7,196c-3.3-10.3-12.5-17.7-23.4-18.7L338.8,164L280.5,27.4c-4.3-10-14.1-16.5-25-16.5c-10.9,0-20.7,6.5-25,16.5
                L172.2,164L24.7,177.3c-10.8,1-20,8.3-23.4,18.7c-3.4,10.3-0.3,21.7,7.9,28.9l111.5,97.8L87.9,467.5c-2.4,10.6,1.7,21.7,10.6,28
                c4.7,3.4,10.3,5.2,15.9,5.2c4.8,0,9.6-1.3,13.9-3.9l127.2-76l127.2,76c9.3,5.6,21,5.1,29.9-1.3c8.8-6.4,13-17.4,10.6-28l-32.9-144.8
                l111.5-97.8C509.9,217.7,513,206.4,509.7,196z"
                                />
                            </svg>
                        </span>
                    </div>
                </ng-template>
            </ngb-rating>
        </div>
    </div>
    <p-footer>
        <button type="button" class="btn btn-secondary" (click)="closeRateModal()">
            {{ 'components.button.buttonCancel' | translate }}
        </button>
        <button type="button" class="btn btn-primary" (click)="closeThisProject()">
            {{ 'projects.pages.details.closeThisProject' | translate }}
        </button>
    </p-footer>
</p-dialog>
